import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router'
import { CondoShell } from './components/Shell.tsx'
import { Home, Login, InvitePage, Profile } from './routes/auth.tsx'
import { CondoHome } from './routes/condo-home.tsx'
import { Acervo, DocumentPage } from './routes/acervo.tsx'
import { Assistant } from './routes/assistant.tsx'
import { Members, Units } from './routes/people.tsx'
import { Settings, AuditLog } from './routes/settings.tsx'
import { Platform } from './routes/platform.tsx'
import { extraCondoRoutes, extraRootRoutes } from './routes/extra.tsx'
import { t } from './lib/i18n.ts'

const rootRoute = createRootRoute({ component: () => <Outlet />, notFoundComponent: NotFound, errorComponent: Crash })

const r = <P extends string>(path: P, component: () => React.ReactNode, parent: any = rootRoute) =>
  createRoute({ getParentRoute: () => parent, path, component })

export const condoRoute = createRoute({ getParentRoute: () => rootRoute, path: '/c/$slug', component: CondoShell })

const routeTree = rootRoute.addChildren([
  r('/', Home),
  r('/entrar', Login),
  r('/convite/$token', InvitePage),
  r('/perfil', Profile),
  r('/plataforma', Platform),
  ...extraRootRoutes(rootRoute),
  condoRoute.addChildren([
    r('/', CondoHome, condoRoute),
    r('/acervo', Acervo, condoRoute),
    r('/acervo/$docId', DocumentPage, condoRoute),
    r('/assistente', Assistant, condoRoute),
    r('/assistente/$cid', Assistant, condoRoute),
    r('/membros', Members, condoRoute),
    r('/unidades', Units, condoRoute),
    r('/config', Settings, condoRoute),
    r('/auditoria', AuditLog, condoRoute),
    ...extraCondoRoutes(condoRoute),
  ]),
])

export const router = createRouter({ routeTree, defaultPreload: 'intent', scrollRestoration: true })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function NotFound() {
  return (
    <main className="mx-auto max-w-lg px-5 py-16">
      <h1 className="text-2xl font-bold">{t('Página não encontrada')}</h1>
      <p className="mt-2 text-tinta-2">{t('O endereço pode estar errado ou você não tem acesso a ele.')}</p>
      <a href="/" className="mt-6 inline-block font-semibold text-caneta underline">
        {t('Ir para o início')}
      </a>
    </main>
  )
}

function Crash({ error }: { error: unknown }) {
  return (
    <main className="mx-auto max-w-lg px-5 py-16">
      <h1 className="text-2xl font-bold">{t('Esta tela falhou')}</h1>
      <p className="mt-2 text-tinta-2">{t('Recarregue a página. Se continuar, avise o síndico ou o suporte com a mensagem abaixo.')}</p>
      <pre tabIndex={0} className="mt-4 overflow-x-auto rounded-ficha border border-pauta bg-folha p-3 text-sm">{error instanceof Error ? error.message : String(error)}</pre>
      <button onClick={() => location.reload()} className="mt-6 font-semibold text-caneta underline">{t('Recarregar')}</button>
    </main>
  )
}
